// extracted by mini-css-extract-plugin
export var boldText = "_8i-4";
export var checkboxContainer = "_8i-6";
export var closeIcon = "_8i-i";
export var container = "_8i-0";
export var drawer = "_8i-8";
export var drawerContent = "_8i-9";
export var extraSmallText = "_8i-5";
export var fulfillmentGroupTable = "_8i-e";
export var largeText = "_8i-3";
export var loadingSpinnerContainer = "_8i-j";
export var mediumText = "_8i-2";
export var narrow = "_8i-f";
export var notificationLink = "_8i-l";
export var packageCheckIconContainer = "_8i-7";
export var slideoutHeaderActions = "_8i-g";
export var slideoutHeaderActionsShifted = "_8i-h";
export var slideoutHeaderContainer = "_8i-a";
export var slideoutModal = "_8i-c";
export var stickyHeaderWrapper = "_8i-b";
export var table = "_8i-k";
export var tableContainer = "_8i-d";
export var tertiaryText = "_8i-1";